import React from 'react';
import ClassAssembly5A  from 'views/ClassAssembly5A';

const ClassAssembly5APage = () => {
    return <ClassAssembly5A />;
  };
  
  export default ClassAssembly5APage;

  //5A